// extracted by mini-css-extract-plugin
module.exports = {"container":"JobItem__container___n1xxO","isSiblingRow":"JobItem__isSiblingRow___DgCRX","timestamp":"JobItem__timestamp___zDsPm","content":"JobItem__content___HNHv-"};